'use client';
import { SvgGoodiesLogo } from '@bazaar-marketplace/assets/goodies-logo';
import { cn } from '@bazaar-marketplace/utils';

import { useScrollY } from '../hooks/use-scroll-y';

const GRADIENT_FULL_AT_SCROLL_Y = 144;

export function PageLogo(props: { hidden: boolean }) {
  const scrollY = useScrollY();
  const gradientOpacity = Math.min(scrollY / GRADIENT_FULL_AT_SCROLL_Y, 1);

  if (props.hidden) {
    return null;
  }

  return (
    <>
      <div
        className="fixed top-0 w-full left-0 right-0 z-30 flex justify-center pt-16 pb-30 pointer-events-none"
        style={{
          background: `linear-gradient(180deg,rgba(0, 0, 0, ${gradientOpacity}) 104px, rgba(237, 221, 83, 0) 100%)`,
          transition: 'background 0.3s ease-in-out',
        }}
      >
        <SvgGoodiesLogo className={cn('w-[100px] h-[26px]')} />
      </div>
    </>
  );
}
